import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./landing.css";
import {
  faAddressCard,
  faCar,
  faCarAlt,
  faMagnifyingGlass,
  faShieldAlt,
  faTable,
  faEnvelope,
  faPhone,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { ReactComponent as Logo } from "../Group1171275083.svg";
import { Link, useNavigate } from "react-router-dom";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";

function Landing() {
  const [scrolled, setScrolled] = useState(false);
  // const Logo = require("../Group1171275083.svg").default
  const navigate = useNavigate();
  const handleEnterClick = () => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  };

  useEffect(() => {
    // const handleScroll = () => {
    //   const headerHeight =
    //     document.querySelector(".header-section").offsetHeight;
    //   if (window.scrollY > headerHeight - 50) {
    //     setScrolled(true);
    //   } else {
    //     setScrolled(false);
    //   }
    // };
    // new code to fix error 27 / 10 / 2025
    const handleScroll = () => {
      const header = document.querySelector(".header-section");
      if (!header) return;

      const headerHeight = header.offsetHeight;
      if (window.scrollY > headerHeight - 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const isLoggedIn = localStorage.getItem("token");
  return (
    <div className="landing-page">
      {/* <nav className={`landnavbar ${scrolled ? "scrolled" : ""}`}>
        <div className="logo">
          <Logo style={{ width: "60px" }} />
        </div>
        <ul className="nav-links">
          <li>
            <Link to="/login">تسجيل الدخول</Link>
          </li>
          <li>
            <Link to="/register">إنشاء حساب</Link>
          </li>
          <li>
            <a href="#features">مميزاتنا</a>
          </li>
          <li>
            <a href="#services">خدماتنا</a>
          </li>
          <li>
            <a href="#why-us">لماذا نحن</a>
          </li>
        </ul>
      </nav> */}
      <Navbar
        expand="lg"
        className={`landnavbar ${scrolled ? "scrolled" : ""}`}
      >
        <Navbar.Brand className="logo" href="#home">
          <Logo style={{ width: "60px" }} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <ul className="nav-links">
            {!isLoggedIn && (
              <li>
                <Link to={"/login"}>تسجيل الدخول</Link>
              </li>
            )}
            {!isLoggedIn && (
              <li>
                <Link to={"/register"}>إنشاء حساب</Link>
              </li>
            )}
            <li>
              <a href={"#features"}>مميزاتنا</a>
            </li>
            <li>
              <a href={"#services"}>خدماتنا</a>
            </li>
            <li>
              <a href={"#why-us"}>لماذا نحن</a>
            </li>
          </ul>
        </Navbar.Collapse>
      </Navbar>
      <header className="header-section">
        <div className="header-overlay"></div>
        <div className="header-content">
          <div className="hero-text">
            <h1>اهلا بك في MotoGates</h1>
            <button className="enter-btn" onClick={handleEnterClick}>
              الدخول
            </button>
          </div>
        </div>
      </header>

      <section id="features" className="features-con">
        <h2>مميزاتنا</h2>
        <section className="features-section">
          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faCarAlt} />
            </div>
            <h3>استعلام فوري عن المخالفات</h3>
            <p>
              يمكنك استعراض المخالفات المرورية الخاصة بك بكل سهولة ويسر، لمعرفة
              المبلغ والتفاصيل
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faTable} />
            </div>
            <h3>إدارة معاملات السيارات</h3>
            <p>
              تسهيل استخراج الأوراق الرسمية بتقديم الخدمات في مكان واحد، لتوفير
              الوقت والجهد
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              {/* <i className="fas fa-hand-holding-usd"></i> */}
              <FontAwesomeIcon icon={faShieldAlt} />
            </div>
            <h3>تسهيل خدمات المكاتب الإدارية</h3>
            <p>
              نوفر لك خدمات المكاتب الحكومية بسهولة تامة، لإنجاز معاملاتك بسرعة
              ودقة دون عناء
            </p>
          </div>
        </section>
      </section>

      <section id="services" className="services-section">
        <h2>خدماتنا</h2>
        <div className="services-grid">
          <div className="service-item">
            <h4>
              تسهيل تسجيل الخدمات{" "}
              <FontAwesomeIcon className="landIcon" icon={faMagnifyingGlass} />{" "}
            </h4>
            <div className="service-icon1"></div>
          </div>

          <div className="service-item">
            <h4>
              {" "}
              تسهيل خدمات التأمين{" "}
              <FontAwesomeIcon className="landIcon" icon={faAddressCard} />
            </h4>
            <div className="service-icon2"></div>
          </div>

          <div className="service-item">
            <h4>
              خدمات مكاتب السيارات{" "}
              <FontAwesomeIcon className="landIcon" icon={faCar} />
            </h4>
            <div className="service-icon3"></div>
          </div>
        </div>
      </section>

      <section id="why-us" className="cta-car-section">
        <h2>لماذا نحن</h2>

        <div className="cta-car-content">
          <div className="cta-text">
            <h2>نحن نوفر لك أفضل تجربة مع خدمات السيارات</h2>
            <div className="feature-list">
              <div className="feature-item">
                <i className="fas fa-check-circle"></i>
                <div>
                  <h3>إدارة البيانات بسهولة</h3>

                  <li style={{ marginRight: "35px" }}>
                    تساعدك على حفظ وتنظيم كل بيانات السيارات في مكان واحد بدقة
                    وسرعة.
                  </li>
                </div>
              </div>
              <div className="feature-item">
                <i className="fas fa-check-circle"></i>
                <div>
                  <h3>تسجيل سريع للبيانات</h3>
                  <p>
                    <li style={{ marginRight: "35px" }}>
                      أضف بيانات معرضك بخطوات بسيطة، مع رفع التفاصيل والصور
                      بسهولة تامة.
                    </li>
                  </p>
                </div>
              </div>
              <div className="feature-item">
                <i className="fas fa-check-circle"></i>
                <h3>شفافية وسلاسة في التعامل</h3>
                <div>
                  <li style={{ marginRight: "35px" }}>
                    تحكم في بياناتك بواجهة سهلة الاستخدام لدعم قراراتك وتعزيز
                    كفاءة العمل.
                  </li>
                </div>
              </div>
            </div>
          </div>
          <div className="cta-car-image">
            {/* The image of the car goes here */}
          </div>
        </div>
      </section>

      <footer className="footer-section">
        <div className="footer-content">
          <div className="footer-column">
            <h3>فروعنا</h3>
            <ul className="branches">
              {/* <li><a href="#how-it-works">كيف تعمل SetGates؟</a></li>
                            <li><a href="#car-inspection">فحص السيارات</a></li>
                            <li><a href="#check-mot">فحص MOT</a></li> */}

              <li className="d-flex align-items-center justify-content-end">
                <span href="info@ibgates.com">
                  مصر - المنصورة - شارع الجلاء
                </span>
                <span>
                  <FontAwesomeIcon icon={faLocationDot} />
                </span>
              </li>
              <li className="d-flex align-items-center justify-content-end">
                <span href="info@ibgates.com" className="location">
                  المملكة العربية السعودية - ابها - شارع معمر بن عبد الله - حى
                  المروج
                </span>
                <span>
                  <FontAwesomeIcon icon={faLocationDot} className="ms-2" />
                </span>
              </li>
            </ul>
          </div>

          <div className="footer-column social-media">
            <h3>تواصل معنا</h3>
            <ul>
              <li className="d-flex align-items-center justify-content-end">
                <a href="mailto:info@ibgates.com" className="fs-6">
                  info@ibgates.com
                </a>
                <span>
                  <FontAwesomeIcon icon={faEnvelope} className="ms-2" />
                </span>
              </li>
              {/* <li className='d-flex align-items-center justify-content-end'>
                                <a href='info@ibgates.com' className='fs-6'>+1 339 399 0570</a>
                                <span><FontAwesomeIcon icon={faPhone} className='ms-2' /></span>
                            </li> */}
              <li className="d-flex align-items-center justify-content-end">
                <a href="tel:+201508770072" className="fs-6">
                  +2 015 0877 0072
                </a>
                <span>
                  <FontAwesomeIcon icon={faPhone} className="ms-2" />
                </span>
              </li>
              <li className="d-flex align-items-center justify-content-end">
                <a
                  href="http://wa.me/+20158770072"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fs-6"
                >
                  +1 339 399 0570
                </a>
                <span>
                  <FontAwesomeIcon icon={faWhatsapp} className="ms-2 fs-5" />
                </span>
              </li>
            </ul>
            <div
              className="social-icons fixed-bottom"
              style={{
                left: "calc(100vw - 80px)",
                bottom: "20px",
                position: "fixed",
                zIndex: 9,
                width: "fit-content",
              }}
            >
              <a
                href="http://wa.me/+20158770072"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  backgroundColor: "#25D366", // لون واتساب الرسمي
                  color: "white",
                  fontSize: "28px",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                  textDecoration: "none",
                }}
              >
                <FontAwesomeIcon icon={faWhatsapp} className="whats-icon" />
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <a
            href="https://ibgates.com/ar"
            rel="noopener noreferrer"
            target="_blank"
            style={{ color: "white", fontWeight: "500" }}
          >
            {" "}
            IBgates جميع الحقوق محفوظة
          </a>
        </div>
      </footer>
    </div>
  );
}

export default Landing;
